<template>
  <div>
    <div class="containerFull" style="min-height:600px">
      <div class="p-grid">
        <div class="p-col-12">
          <h2 style="border-bottom: 1px solid #cfcfcf;" class="p-pb-5 p-mt-6 titulo-admin p-ml-2">
            Listado de Tarifas
          </h2>
          <DataTable
            ref="dt"
            :value="tarifas"
            dataKey="id"
            :paginator="true"
            :rows="10"
            :filters="filters"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25]"
            currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} tarifas"
            class="p-datatable-responsive-demo p-mt-5"
            style="margin-bottom:100px"
            :loading="loading"
          >
            <template #header>
              <div
                class="table-header"
                style="align-items: center;display: flex;"
              >
                <Button
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-info p-mr-3"
                  @click="openNew"
                  :disabled="loading"
                  v-tooltip.rigth="'Agregar nuevo'"
                  name="nuevo"
                />
                <span class="p-input-icon-left" style="margin-left: auto;">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters['global']"
                    placeholder="Buscar..."
                  />
                </span>
              </div>
            </template>
            <Column
              field="costo_por_minuto"
              header="Valor del minuto (COP)"
              :sortable="true"
              ><template #body="slotProps">
                <span class="p-column-title">Valor del minuto (COP)</span>
                {{ formatNumber(slotProps.data.costo_por_minuto) }}
              </template></Column
            >
            <Column field="comentario" header="Comentario" :sortable="true"
              ><template #body="slotProps">
                <span class="p-column-title">Comentario</span>
                {{ slotProps.data.comentario }}
              </template></Column
            >
            <Column field="riesgo" header="Riesgo" :sortable="true"
              ><template #body="slotProps">
                <span class="p-column-title">Riesgo</span>
                {{ slotProps.data.riesgo }}
              </template></Column
            >
            <Column field="limite" header="Limite (min)" :sortable="true"
              ><template #body="slotProps">
                <span class="p-column-title">Limite (min)</span>
                {{ slotProps.data.limite }}
              </template></Column
            >
            <Column :exportable="false">
              <template #body="slotProps">
                <span class="p-column-title">Acciones</span>
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success p-mr-2"
                  @click="editTarifa(slotProps.data)"
                  v-tooltip.top="'Editar'"
                  name="editar"
                />
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning"
                  @click="confirmDeleteTarifa(slotProps.data)"
                  v-tooltip.top="'Eliminar'"
                  name="eliminar"
                />
              </template>
            </Column>
          </DataTable>

          <Dialog
            :closable="false"
            :visible="tarifaDialog"
            :style="{ width: '450px' }"
            header="Detalles de la Tarifa"
            :modal="true"
            class="p-fluid"
            :contentStyle="{ overflow: 'visible' }"
          >
            <div class="p-grid">
              <div class="p-field p-col-12">
                <label for="riesgo">Riesgo</label>
                <Dropdown
                  id="riesgo"
                  v-model="tarifa.riesgo"
                  :options="riesgos"
                  placeholder="Seleccione un riesgo"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid': submitted && !tarifa.riesgo,
                  }"
                />
                <small class="p-invalid" v-if="submitted && !tarifa.riesgo"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="costo_por_minuto">Costo por minuto (COP)</label>
                <InputText
                  id="costo_por_minuto"
                  type="number"
                  v-model.number="tarifa.costo_por_minuto"
                  required="true"
                  autofocus
                  min="1"
                  :class="{
                    'p-invalid': submitted && !tarifa.costo_por_minuto,
                  }"
                />
                <small
                  class="p-invalid"
                  v-if="submitted && !tarifa.costo_por_minuto"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="limite">Limite (minutos)</label>
                <InputText
                  id="limite"
                  type="number"
                  v-model.number="tarifa.limite"
                  required="true"
                  autofocus
                  min="1"
                  :class="{
                    'p-invalid': submitted && !tarifa.limite,
                  }"
                />
                <small class="p-invalid" v-if="submitted && !tarifa.limite"
                  >El campo es requerido</small
                >
              </div>
              <div class="p-field p-col-12">
                <label for="comentario">Comentario</label>
                <InputText
                  id="comentario"
                  v-model.trim="tarifa.comentario"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid': submitted && !tarifa.comentario,
                  }"
                />
                <small class="p-invalid" v-if="submitted && !tarifa.comentario"
                  >El campo es requerido</small
                >
              </div>
            </div>
            <template #footer>
              <Button
                label="Cancelar"
                icon="pi pi-times"
                class="p-button-text"
                @click="hideDialog"
                name="cancelar"
              />
              <Button
                label="Guardar"
                icon="pi pi-check"
                class="p-button-text"
                @click="saveTarifa"
                :disabled="loading"
                name="guardar"
              />
            </template>
          </Dialog>
          <Dialog
            :visible="deleteTarifaDialog"
            :style="{ width: '450px' }"
            header="Confirmación de eliminación"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="tarifa"
                >Esta seguro que desea eliminar la tarifa seleccionada?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteTarifaDialog = false"
                name="cancelar"
              />
              <Button
                label="Si"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteTarifa"
                name="aceptar"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TarifasService from "../service/tarifas.service";
export default {
  metaInfo: {
    title: 'Backoffice - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Backoffice - QualityCare',
        content: 'Administración del sitio web',
      },
    ],
  },
  data() {
    return {
      tarifasService: null,
      filters: {},
      tarifa: {},
      tarifas: [],
      tarifaDialog: false,
      submitted: false,
      loading: false,
      id_mayor: 0,
      riesgos: [2,3, 4, 5],
      deleteTarifaDialog: false,
    };
  },
  created() {
    this.tarifasService = new TarifasService();
  },
  mounted() {
    this.recuperarTarifas();
  },
  methods: {
    recuperarTarifas() {
      this.loading = true;
      this.tarifasService
        .allTarifas()
        .then((result) => {
          if (result.data.data) {
            this.tarifas = [...result.data.data];
          }
          if (this.tarifas.length == 0) {
            this.id_mayor = 0;
          } else {
            this.id_mayor = this.tarifas[0].id;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al cargar las tarifas",
            life: 3000,
          });
        });
    },
    openNew() {
      this.tarifa = {};
      this.submitted = false;
      this.tarifaDialog = true;
    },
    hideDialog() {
      this.tarifaDialog = false;
      this.submitted = false;
    },
    editTarifa(tarifa) {
      this.tarifa = { ...tarifa };
      this.tarifaDialog = true;
    },
    async saveTarifa() {
      this.submitted = true;
      if (
        this.tarifa.costo_por_minuto &&
        this.tarifa.riesgo &&
        this.tarifa.limite
      ) {
        if (this.tarifa.costo_por_minuto <= 0 || this.tarifa.limite <= 0) {
          this.$toast.add({
            severity: "warn",
            summary: "Alerta",
            detail:
              "El valor del costo por minuto y el limite en minutos deben ser mayor a cero",
            life: 3000,
          });
          return false;
        }
        this.loading = true;
        if (this.tarifa.id) {
          //edicion de tarifa
          let idTarifaEnEdicion = this.tarifa.id;
          let tarifaEditada = {};
          await this.tarifasService
            .updateTarifa(this.tarifa)
            .then((result) => {
              tarifaEditada = result.data.data;
              this.$set(
                this.tarifas,
                this.findIndexById(idTarifaEnEdicion),
                tarifaEditada
              );
              this.$toast.add({
                severity: "success",
                summary: "Felicidades",
                detail: "Tarifa actualizado",
                life: 3000,
              });
            })
            .catch((err) => {
              console.log(err);
            });
          this.loading = false;
        } else {
          //nueva tarifa
          await this.tarifasService
            .crearTarifa(this.tarifa)
            .then((result) => {
              this.tarifas.push(result.data.data);
              this.$toast.add({
                severity: "success",
                summary: "Felicidades",
                detail: "Tarifa creada",
                life: 3000,
              });
            })
            .catch((err) => {
              console.log(err);
            });
          this.loading = false;
        }
        this.tarifaDialog = false;
        this.tarifa = {};
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.tarifas.length; i++) {
        if (this.tarifas[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    confirmDeleteTarifa(tarifa) {
      this.tarifa = tarifa;
      this.deleteTarifaDialog = true;
    },
    deleteTarifa() {
      this.tarifasService
        .eliminarTarifa({ id: this.tarifa.id })
        .then(() => {
          this.tarifas = this.tarifas.filter(
            (val) => val.id !== this.tarifa.id
          );
          this.deleteTarifaDialog = false;
          this.tarifa = {};
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Tarifa eliminada",
            life: 3000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatNumber(numero) {
      return new Intl.NumberFormat("de-DE").format(numero);
    },
  },
};
</script>

<style lang="scss" scoped>
.tituloUsuarios {
  font-size: 28px;
  font-weight: 400;
  margin-right: 50px;
}
.muyLargo {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
.reserva-badge {
  padding: 5px;
  border-radius: 5px;
}

.vigente {
  background-color: #8eff9a;
  color: gray;
}
.no-vigente {
  background-color: #ff8e8e;
  color: gray;
}
.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 40em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
        }
      }
    }
  }
}
</style>
